import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {useState} from "react";
import {config} from "../config";
import {HashLoader} from "react-spinners";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
// import FormGroup from "@mui/material/FormGroup";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';


export default function TableWithDictData({csvfile_id}) {
    const [loading, setLoading] = useState(false);
    const [table_shown, setTableShown] = useState(false);
    const [errorLoadingTable, setErrorLoadingTable] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const API_URL = config.api_url;

    const [header, setHeader] = useState(null);
    const [data, setData] = useState(null);
    const [nrows, setNRow] = useState(null);
    const [originalHeader, setOriginalHeader] = useState(null);

    const [columnOrder, setColumnOrder] = React.useState('original');
    const [csvReadMethod, setCsvReadMethod] = React.useState('default');
    const [userSelectNRow, setUserSelectNRow] = React.useState(15);

    async function fetchCSVData(csvfile_id, params) {
        setLoading(true);
        setErrorLoadingTable(false);
        setErrorMsg("");
        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(params)
        };
        // try {
        fetch(API_URL + '/csvfile_data_new/' + csvfile_id + "/", requestOptions)
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                if (data.error === undefined) {
                    setOriginalHeader(data.header);
                    setData(data.data);
                    setNRow(data.nrows);

                    // apply order
                    let tmp_header = [...data.header];
                    if (columnOrder === "alpha_asc") {
                        tmp_header.sort();
                        setHeader(tmp_header);
                    } else if (columnOrder === "alpha_desc") {
                        tmp_header.reverse();
                        setHeader(tmp_header);
                    } else {
                        setHeader(data.header);
                    }
                } else {
                    setErrorMsg(data.error);
                    setErrorLoadingTable(true);
                }
            })
            .catch(error => {
                console.log('error is', error);
                setErrorMsg(error);
                setErrorLoadingTable(true);
            })
            .finally(() => setLoading(false));
        // } catch (error) {
        //     console.error('Error fetching datasets:', error);
        //     setErrorMsg(error);
        //     setErrorLoadingTable(true);
        //     setLoading(false);
        // }
    }

    function handle_click() {
        if (table_shown) {
            setTableShown(false);
        } else {
            if (errorLoadingTable) {
                return;
            }
            if (!data) {
                fetchCSVData(csvfile_id, {"n_rows": 15});
            }
            setTableShown(true);
        }
    }


    const handleChangeColumnOrder = (event) => {
        setColumnOrder(event.target.value);
        let tmp_header = [...header];
        if (header) {
            if (event.target.value === "alpha_asc") {
                tmp_header.sort();
                setHeader(tmp_header);
            } else if (event.target.value === "alpha_desc") {
                tmp_header.reverse();
                setHeader(tmp_header);
            } else {
                setHeader(originalHeader);
            }
        }
    };

    const handleChangeNRows = (event) => {
        setUserSelectNRow(event.target.value);
        fetchCSVData(csvfile_id, {"n_rows": event.target.value, "read_method": csvReadMethod});
    }

    const handleChangeReadMethod = (event) => {
        setCsvReadMethod(event.target.value);
        fetchCSVData(csvfile_id, {"n_rows": userSelectNRow, "read_method": event.target.value});
    }

    return (
        <div>
            <Box component="form"
                 sx={{
                     '& > :not(style)': {m: 1, width: '30ch'},
                 }}>

                <FormControlLabel control={<Switch
                    checked={table_shown}
                    onChange={handle_click}
                    disabled={errorLoadingTable}
                    inputProps={{'aria-label': 'controlled'}}
                />} label={table_shown ? "Click to collapse table" : "Click to Show Table"}/>

                {(data && table_shown) ? <FormControl>
                    <InputLabel id="demo-simple-select-label">Column Order</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={columnOrder}
                        label="Column Order"
                        onChange={handleChangeColumnOrder}
                        style={{width: "20ch"}}
                    >
                        <MenuItem value="original">Original</MenuItem>
                        <MenuItem value="alpha_asc">Name ASC</MenuItem>
                        <MenuItem value="alpha_desc">Name DESC</MenuItem>
                    </Select>
                </FormControl> : ""}

                {(data && table_shown) ? <FormControl>
                    <InputLabel id="demo-simple-select-label"># of rows</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={userSelectNRow}
                        defaultValue={15}
                        label="# of rows"
                        onChange={handleChangeNRows}
                        style={{width: "20ch"}}
                    >
                        <MenuItem value={15}>15</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={200}>200</MenuItem>
                    </Select>
                </FormControl> : ""}

                {(data && table_shown) ? <FormControl>
                    <InputLabel id="select-read-method-label">Read Method</InputLabel>
                    <Select
                        labelId="select-read-method"
                        id="id-select-read-method"
                        value={csvReadMethod}
                        defaultValue="default"
                        label="File Read Method"
                        onChange={handleChangeReadMethod}
                        style={{width: "20ch"}}
                    >
                        <MenuItem value={"default"}>File Order</MenuItem>
                        <MenuItem value={"random"}>Random</MenuItem>
                    </Select>
                </FormControl> : ""
                }


            </Box>

            {
                (data && table_shown) ? <Paper sx={{width: '100%', overflow: 'hidden'}}>
                    <TableContainer sx={{maxHeight: 640}}>
                        <Table stickyHeader aria-label="sticky table" style={{border: "2px solid grey"}}>
                            <TableHead>
                                <TableRow>
                                    {header.map((field) => <TableCell key={`id-header-${field}`}
                                                                      style={{
                                                                          minWidth: 170,
                                                                          background: "grey",
                                                                          color: "white"
                                                                      }}>{field}</TableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[...Array(nrows).keys()].map((row_id) =>
                                    <TableRow key={`id-row-${row_id}`}
                                              sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                        {header.map((field) => <TableCell key={`id-row-${row_id}-cell-${field}`}>
                                            {data[field][row_id]}
                                        </TableCell>)}
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper> : ""
            }
            {
                errorLoadingTable ? <p>Cannot load table: {errorMsg}</p> : ""
            }
            {
                loading ?
                    <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                        <HashLoader
                            loading={loading}
                            size={100}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            color={"#36d7b7"}
                        /></div> : ""
            }
        </div>
    )
        ;
}